import { Link, useLocation } from 'react-router-dom';
import { Settings, ExternalLink } from 'lucide-react';

// Routes where the banner is hidden so the visual editors keep the full canvas.
const HIDE_ON: string[] = [
  '/admin/page-builder',
  '/admin/pages',
  '/admin/homepage',
  '/admin/about',
  '/admin/editor-frame',
];

export function AdminViewBanner() {
  const { pathname } = useLocation();
  if (HIDE_ON.some((route) => pathname === route || pathname.startsWith(`${route}/`))) {
    return null;
  }

  return (
    <div className="sticky top-0 z-30 flex h-9 items-center justify-between bg-primary px-4 text-primary-foreground text-xs">
      <div className="flex items-center gap-1.5 font-medium opacity-80">
        <Settings className="h-3 w-3" />
        <span>Admin view</span>
      </div>
      <Link
        to="/"
        className="flex items-center gap-1.5 rounded bg-white/20 px-2 py-1 hover:bg-white/30 transition-colors font-medium"
      >
        <ExternalLink className="h-3 w-3" />
        View your site
      </Link>
    </div>
  );
}
